import { Source } from '@swf/core/enums';

// TODO: rename params. What's the hek "promoIa" or "gclid" in English?
export const getPID = (
  promoAms: string,
  promoIa: string,
  gclid: string | undefined,
  utmMedium: string | undefined,
  utmSource: string | undefined
) => {
  if (!promoAms && !promoIa) {
    return Source.Direct;
  }

  if (!promoAms && promoIa) {
    return Source.Affiliate;
  }

  if (promoAms && !promoIa) {
    if (gclid) {
      return Source.Adwords;
    }

    if (utmMedium === 'display') {
      return Source.Display;
    }

    if (utmSource) {
      return utmSource;
    }

    return promoAms.search(/^psio/gi) >= 0 ? Source.SEO : Source.Affiliate;
  }

  if (promoAms && promoIa) {
    if (gclid) {
      return Source.Adwords;
    }

    if (utmSource) {
      return utmSource;
    }
  }

  return Source.Affiliate;
};
